/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Ticket } from '@touchplan/common';
import { PlanAccessCheck } from 'src/app/services/PlanAccessCheck';

export class TicketContext {
	public projectId: string;
	public planId: string;
	public userId: string;

	// Observables for stuff that can potentially change dynamically:
	public ticketId$: Observable<string>;
	public ticketIsEditable$?: Observable<boolean>;
	public planIsLocked$: Observable<boolean>;
	public planIsLockedSync: boolean;

	// Platform- and/or device-specific variables:
	public openInLightBox = false; // default false, for desktop
	public fixedDimensionsUI = false; // default false, for desktop

	/**
	 * Helper function for initializing the "ticketId$" and "ticketIsEditable$" fields
	 */
	public initTicketFields(tickets$: Observable<Ticket>, planAccessCheck: PlanAccessCheck) {
		this.ticketId$ = tickets$.pipe(map((ticket) => ticket.$id));
		this.ticketIsEditable$ = planAccessCheck.getTicketIsEditable$(tickets$);
		this.planIsLocked$ = planAccessCheck.hasRestrictedAccess$;
		this.planIsLocked$.pipe(
			tap((readOnly) => {
				this.planIsLockedSync = readOnly;
			})
		);
	}
}
